import { useMemo } from 'react'
import { AxiosInstance } from 'axios'
import { useApContextDataGql } from './useApContextData.gql'
import { useApContextDataRest } from './useApContextData.rest'

export type Source = 'graphql' | 'rest'
interface Args {
  aiCode?: string
  diCode?: string
  source?: Source
  restClient?: AxiosInstance
}

export function useApContextData({ source = 'graphql', ...rest }: Args) {
  const impl = useMemo(
    () =>
      source === 'graphql'
        ? (p: Args) => useApContextDataGql(p.aiCode)
        : (p: Args) => useApContextDataRest(p.aiCode, p.diCode, p.restClient),
      // `source` is assumed _stable_ for the lifetime of the component.
      // If it can change, lift it a level higher so the chosen hook never flips.
    [source]
  )

  return impl(rest)
}
